module.exports = __webpack_public_path__ + "img/pepper.e6c05a87.png";